let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jjqgH")).then(() => parcelRequire('43JzQ'));